import React, { useState, useEffect, useCallback } from "react";
import { GPSWrapper } from "../../../utils/common";
import _ from "lodash";
import "../../../pages/Search/New/NewPage.scss";
import { NewInputProps, GetUiElements } from './OriginInput.util';
import { fetchCityList, fetchOriginCity } from './origin.util';
import { LocationDetails, Coords } from "../../../schemas/Search/Search.schema";
import BackgroundGeolocation from "@transistorsoft/capacitor-background-geolocation";
import { Anywhere } from "app/utils/constants";

export const NewInput: React.FC<NewInputProps> = (props) => {
  const {
    currentLocationOff,
    onTimeZoneChange,
    Error,
    InputValue,
    handleChange,
    InputName,
    getLocalTime,
    keyboardshowHandler,
    locationValue,
    keyboardhideHandler,
    isDestination,
    useHandler,
    setErrorValue,
    placeholder,
    isCapacitor,
    country: selectedCountry = '',
    deFaultValue,
    postalCode: selectedPostalCode = ''
  } = props

  const [options, setOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(InputValue);
  const [latLng, setLatLng] = useState<Coords>({
    lat: "",
    lng: "",
  });
  const [showSuggention, setShowSuggention] = useState(false);
  const [edited, setEdited] = useState(false);
  const [inputPalceholder, setPlaceholder] = useState(
    placeholder ? placeholder : ""
  );
  const [currentLocation, setcurrentLocation] = useState<LocationDetails>({
    cityName: "",
    country: "",
    postalCode: "",
    coords: {
      lat: "",
      lng: ""
    },
    timeZone: "EST"
  });
  const [showError, setShowError] = useState(false);
  const [backClicked, setBackClicked] = useState(true);
  const [country, setCountry] = useState("");
  const [select, setSelect] = useState(false);
  const [focusOut, setFocusOut] = useState(false);
  const [postalCode, setPostalCode] = useState("")
  const pattern = /^[a-zA-Z0-9, ]*$/;

  const clearError = () => {
    setShowError(false);
    setErrorValue(false, InputName);
  }

  useEffect(() => {
    if (isCapacitor && !currentLocationOff && currentLocationOff !== undefined) {
      getCurrentGeoPosition();      //Get Current Geo Position for New search screen open
      BackgroundGeolocation.onProviderChange((event) => {   // Get Current Geo Position when user changes the settings whenever a change in the state of the device's Location Services has been detected.
        if (event.status === BackgroundGeolocation.AUTHORIZATION_STATUS_ALWAYS
           || event.status === BackgroundGeolocation.AUTHORIZATION_STATUS_WHEN_IN_USE) {
          getCurrentGeoPosition();
        } else {
          setSelectedCity(Anywhere);
        }
      });
    }
  }, [currentLocationOff]);

  useEffect(() => {
    if (focusOut && InputValue === "") {
      setOptions([]);
    }
  }, [focusOut, InputValue])

  useEffect(() => {
    const { cityName, country, postalCode, coords: { lat, lng } = { lat: "", lng: "" } } = currentLocation;
    if (!isDestination && !edited && currentLocation.cityName && InputValue === deFaultValue) {
      setSelectedCity(cityName);
      setPlaceholder("");
      handleChange({
        target: {
          name: InputName,
          value: currentLocation.cityName,
          backClicked,
          lat,
          lng,
          country,
          currentLocation,
          postalCode: postalCode
        },
      });
    }
  }, [isDestination, edited, currentLocation]);

  useEffect(() => {
    if (edited && (country || postalCode || (latLng.lat && latLng.lng))) {
      handleChange({
        target: {
          name: InputName,
          value: selectedCity,
          backClicked,
          lat: latLng.lat,
          lng: latLng.lng,
          country,
          currentLocation,
          postalCode
        },
      });
    }
  }, [country, postalCode, latLng.lat, latLng.lng]);

  useEffect(() => {
    if (!locationValue) {
      setSelectedCity("");
    } else {
      setSelect(true);
      setSelectedCity(currentLocation.cityName);
    }
  }, [locationValue]);

  useEffect(() => {
    setSelectedCity(InputValue)
  }, [InputValue]);

  useEffect(() => {
    setShowError(Error);
  }, [Error]);

  const getCurrentGeoPosition = () => {
    GPSWrapper.details.getCurrentPosition((lat: any, long: any) => {
      fetchOriginCity(`${lat},${long}`, setCountry, setPostalCode, clearError,
        onTimeZoneChange, getLocalTime, setcurrentLocation);
      setLatLng({ lat, lng: long });
    });
  }

  const handleValueChange = (event: any) => {
    const preValue = selectedCity?.trim();

    if (!pattern.test(event.target.value) && !select) {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]*/g, "");
    }
    setSelectedCity(event.target.value);
    setEdited(true);
    if (selectedCity !== event.target.value) {
      const newValue = event.target.value.trim();
      if (preValue !== newValue) {
        callAPI(event.target.value);
      }
    }
    if (edited) {
      setPlaceholder("");
    }

    if (select) {
      handleChange({
        target: {
          name: InputName,
          value: event.target.value,
          backClicked,
          lat: latLng.lat,
          lng: latLng.lng,
          country,
          currentLocation,
          postalCode
        },
      });
    } else {
      handleChange({
        target: {
          name: InputName,
          value: event.target.value,
          backClicked,
          lat: latLng.lat,
          lng: latLng.lng,
          country: selectedCountry,
          currentLocation,
          postalCode: selectedPostalCode
        },
      });
      if (onTimeZoneChange) {
        onTimeZoneChange("");
      }
    }
    if(selectedCity === Anywhere)
    {
      setSelect(true)
    }
    else{
    setSelect(false);
    }
  };

   /* to call PCmiler api for city list need basis*/
  const callAPI = useCallback(
    _.debounce((value: string) => fetchCityList(value,
      currentLocation,
      setOptions,
      setShowSuggention,
      setSelectedCity,
      setCountry,
      setPostalCode,
      setLatLng,
      clearError,
      onTimeZoneChange,
      getLocalTime,
      isDestination,
      useHandler,
      keyboardshowHandler,
      keyboardhideHandler), 500),
    [currentLocation.cityName]
  );

  return (
    <>
      <GetUiElements
        {...props}
        showError={showError}
        handleValueChange={handleValueChange}
        selectedCity={selectedCity}
        inputPalceholder={inputPalceholder}
        showSuggention={showSuggention}
        currentLocation={currentLocation}
        options={options}
        setSelectedCity={setSelectedCity}
        setEdited={setEdited}
        setBackClicked={setBackClicked}
        setFocusOut={setFocusOut}
        focusOut={focusOut}
        setShowSuggention={setShowSuggention}
        setShowError={setShowError}
        setErrorValue={setErrorValue}
        setCountry={setCountry}
        setPostalCode={setPostalCode}
        setSelect={setSelect}
        select={select}
        setLatLng={setLatLng}
      />
    </>
  );
};
